'use client';

const defaultProps = {
  variant: "default",
  as: "li"
};
export {
  defaultProps
};
